import {
	BREAKPOINTS_OPTIONS,
	ERROR_COLOR,
	PRIMARY_COLOR,
	SPACING,
	SUCCESS_COLOR,
} from '@constants/themes.constants';
import { createTheme } from '@mui/material';

const defaultTheme = createTheme({
	breakpoints: BREAKPOINTS_OPTIONS,
	palette: {
		error: ERROR_COLOR,
		primary: PRIMARY_COLOR,
		secondary: {
			contrastText: 'white',
			main: '#AEAEAE',
		},
		success: SUCCESS_COLOR,
	},
	spacing: SPACING,
});

export default defaultTheme;
